import React from 'react'

export const InvestorProject = () => {
  return (
    <div>InvestorProject</div>
  )
}
